import {
  Component,
  ViewChild,
  EventEmitter,
  Output,
  OnInit,
  AfterViewInit,
  Input,
  forwardRef,
} from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
// import * as googlemaps from 'googlemaps';

@Component({
  selector: "ads-googleplacesautocomplete",
  templateUrl: "./google-places-autocomplete.component.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GooglePlacesAutocompleteComponent),
      multi: true,
    },
  ],
})
export class GooglePlacesAutocompleteComponent
  implements OnInit, AfterViewInit, ControlValueAccessor
{
  public val: any = "";
  public value:string;
  public selectedvalue:any = ""
  onChange = (value:any) => {};
  onTouched: any = () => { };
  @Input("addressType") addressType: string;
  @Input("countryCode") countryCode: string;
  @Input("disabled") disabled: boolean = false;
  @Input("required") required: boolean = false;
  @Input("style") style: string = "";
  @Input("placeholder") placeholder: string = "";
  @Output() AddressChange: EventEmitter<any> = new EventEmitter();
  @ViewChild("googleplacesautocomplete") googleplacesautocomplete: any;
  autocompleteInput: string;
  place:any;
  queryWait: boolean;

  constructor() {}
  public onBlur() {
    this.onTouched();
  }
  writeValue(obj: any): void {
    this.value = obj ? obj : '';
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  ngOnInit() {}

  ngAfterViewInit() {
    this.getPlaceAutocomplete();
  }

  public getPlaceAutocomplete() {
    const autocomplete = new google.maps.places.Autocomplete(
      this.googleplacesautocomplete.nativeElement,
      {
        componentRestrictions: { country: this.countryCode },
        types: [this.addressType], // 'establishment' / 'address' / 'geocode'
      },
    );
    google.maps.event.addListener(autocomplete, "place_changed", () => {
      const place = autocomplete.getPlace();
      if(this.value.length > 0){
        this.onChange(place.formatted_address);
      }
      this.invokeEvent(place);
    });
  }

  invokeEvent(place: Object) {
    this.AddressChange.emit(place);
  }
}
